import { Button } from 'antd';
import {
    ArrowDownOutlined,
    ArrowUpOutlined,
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    SaveOutlined,
    UndoOutlined,
} from '@ant-design/icons';
import { Confirm } from 'app/shared/confirm/confirm';
import React, { useRef, useState } from 'react';
import { useDesktop } from 'app/hooks/useDesktop';
import s from './index.module.scss';
import { useClickOutside } from 'app/hooks/useClickOutside';
import classNames from 'classnames';

export const DiscardConfirm = ({ onDiscard, hideConfirmDiscard }) => {
    const confirm = () => {
        onDiscard();
        hideConfirmDiscard();
    };
    return (
        <>
            <div>Вы уверены, что хотите сбросить изменения?</div>
            <div className={s.controls}>
                <Button onClick={hideConfirmDiscard}>Нет</Button>
                <Button onClick={confirm} className={s.confirm_btn}>
                    Да
                </Button>
            </div>
        </>
    );
};

const OnSaveConfirm = ({ onSave, hideOnSaveConfirm }) => {
    const confirm = () => {
        onSave();
        hideOnSaveConfirm();
    };
    return (
        <>
            <div>Вы уверены, что хотите сохранить изменения?</div>
            <div className={s.controls}>
                <Button onClick={hideOnSaveConfirm}>Нет</Button>
                <Button onClick={confirm} className={s.confirm_btn}>
                    Да
                </Button>
            </div>
        </>
    );
};

export const LendingActions = ({
    onEdit,
    onDiscard,
    onSave,
    onDelete,
    onCopy,
    onUp,
    onDown,
    isMobileMenu,
    className,
}) => {
    const isDesktop = useDesktop();

    const [confirmDiscardModal, setConfirmDiscardModal] = useState(false);
    const [confirmOnSaveModal, setConfirmOnSaveModal] = useState(false);
    const discardRef = useRef();
    const onSaveRef = useRef();

    const showConfirmDiscard = () => {
        setConfirmDiscardModal(true);
    };
    const hideConfirmDiscard = () => {
        setConfirmDiscardModal(false);
    };
    const showOnSaveConfirm = () => {
        setConfirmOnSaveModal(true);
    };
    const hideOnSaveConfirm = () => {
        setConfirmOnSaveModal(false);
    };
    useClickOutside(discardRef, hideConfirmDiscard);
    useClickOutside(onSaveRef, hideOnSaveConfirm);
    return (
        <div className={'lending-actions'}>
            <div className={classNames('lending-actions__crud', className)}>
                {onEdit ? (
                    <Button
                        title={'Редактировать'}
                        icon={<EditOutlined />}
                        onClick={onEdit}
                    />
                ) : null}
                {onDiscard && isDesktop ? (
                    <Confirm
                        onConfirm={onDiscard}
                        description={
                            'Вы уверены что хотите сбросить изменения?'
                        }
                    >
                        <Button title={'Сбросить'} icon={<UndoOutlined />} />
                    </Confirm>
                ) : (
                    <div
                        className={`${isMobileMenu ? s.mobile_menu : ''} ${
                            s.discard_wrap
                        }`}
                        ref={discardRef}
                    >
                        {confirmDiscardModal && (
                            <div className={s.discard_content}>
                                <DiscardConfirm
                                    onDiscard={onDiscard}
                                    hideConfirmDiscard={hideConfirmDiscard}
                                />
                            </div>
                        )}
                        <Button
                            title={'Сбросить'}
                            icon={<UndoOutlined />}
                            onClick={showConfirmDiscard}
                        />
                    </div>
                )}
                {onSave && isDesktop ? (
                    <Confirm
                        onConfirm={onSave}
                        description={
                            'Вы уверены что хотите сохранить изменения?'
                        }
                    >
                        <Button title={'Сохранить'} icon={<SaveOutlined />} />
                    </Confirm>
                ) : (
                    <div
                        className={`${isMobileMenu ? s.mobile_menu : ''} ${
                            s.on_save_wrap
                        }`}
                        ref={onSaveRef}
                    >
                        {confirmOnSaveModal && (
                            <div className={s.on_save_content}>
                                <OnSaveConfirm
                                    onSave={onSave}
                                    hideOnSaveConfirm={hideOnSaveConfirm}
                                ></OnSaveConfirm>
                            </div>
                        )}{' '}
                        <Button
                            title={'Сохранить'}
                            icon={<SaveOutlined />}
                            onClick={showOnSaveConfirm}
                        />
                    </div>
                )}
                {onCopy ? (
                    <Button
                        onClick={onCopy}
                        title={'Скопировать'}
                        icon={<CopyOutlined />}
                    />
                ) : null}
                {onDelete ? (
                    <Confirm
                        onConfirm={onDelete}
                        description={'Вы уверены что хотите удалить раздел?'}
                    >
                        <Button title={'Удалить'} icon={<DeleteOutlined />} />
                    </Confirm>
                ) : null}
            </div>
            <div className={'lending-actions__position'}>
                {onUp ? (
                    <Button
                        onClick={onUp}
                        shape="circle"
                        icon={<ArrowUpOutlined />}
                    />
                ) : null}
                {onDown ? (
                    <Button
                        onClick={onDown}
                        shape="circle"
                        icon={<ArrowDownOutlined />}
                    />
                ) : null}
            </div>
        </div>
    );
};
